import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import apiPath from '../../../utils/apiPath'
import { apiGet } from 'utils/apiFetch'
import AuctionProperty from './AuctionProperty'

const tabBtnClass =
  'inline-block py-3 px-8 text-md xl:text-lg font-semibold border-b-2'
const tabActiveClass = 'border-lime-500 text-lime-500'
const tabBorderNoneClass = 'border-transparent'
const TAB_ACTIVE_AUCTION = 'active'
const TAB_EXPIRED_AUCTION = 'expired'

const AuctionDetail = ({ item }) => {
  const [pendingStatus] = useState('active')
  const [auctionData, setAuctionData] = useState([])
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const { t } = useTranslation()
  const [page, setPage] = useState(1)

  const [defaultTab, setDefaultTab] = useState('active')
  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }
  const handleTabClick = async action => {
    const payload = {
      status: defaultTab,
      userId: item?._id,
      page
    }

    const path = apiPath.getUserAuctions
    const result = await apiGet(path, payload)
    if (result?.data?.success) {
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setAuctionData(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null
      })
    }
    // setDefaultTab(action)
  }
  useEffect(() => {
    handleTabClick()
  }, [defaultTab,page])
  return (
    <>
      <div className='pb-3'>
        <ul className='border-b flex'>
          <li className='mr-0 xl:mr-5'>
            <button
              onClick={() => setDefaultTab(TAB_ACTIVE_AUCTION)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_ACTIVE_AUCTION,
                [tabBorderNoneClass]: defaultTab !== TAB_ACTIVE_AUCTION
              })}
            >
              {t('O_ACTIVE_AUCTION')}
            </button>
          </li>
          <li className='mx-0 xl:mx-5'>
            <button
              onClick={() => setDefaultTab(TAB_EXPIRED_AUCTION)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_EXPIRED_AUCTION,
                [tabBorderNoneClass]: defaultTab !== TAB_EXPIRED_AUCTION
              })}
            >
              {t('O_EXPIRED_AUCTION')}
            </button>
          </li>
        </ul>
      </div>
      {defaultTab === TAB_ACTIVE_AUCTION
        ? (
          <AuctionProperty auctionData={auctionData} pendingStatus={pendingStatus} paginationObj={paginationObj} handlePageClick={handlePageClick} page={page}/>)
        : defaultTab === TAB_EXPIRED_AUCTION
          ? (
            <AuctionProperty
              pendingStatus='expired'
              auctionData={auctionData}
              paginationObj={paginationObj}
              handlePageClick={handlePageClick}
               page={page}
            />)
          : null}
    </>
  )
}

export default AuctionDetail
